import { PlayCircle } from 'lucide-react';

export default function HeroSection() {
  const handleWatchDemo = () => {
    const el = document.getElementById('demo');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background video */}
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover"
      >
        <source src="/videos/hero-bg.webm" type="video/webm" />
        <source src="/videos/hero-bg.mp4" type="video/mp4" />
      </video>

      {/* Dark overlay gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70" />

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center text-center px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto">
        {/* Eyebrow pill */}
        <div className="mb-6 inline-flex items-center px-4 py-2 rounded-full bg-white/10 backdrop-blur border border-white/20 text-white text-sm font-medium">
          Now in Beta &mdash; Join 500+ Fleets
        </div>

        {/* H1 */}
        <h1 className="text-[56px] md:text-[72px] font-extrabold text-white leading-tight tracking-tight mb-6">
          Move Loads.{' '}
          <span className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">
            Not Spreadsheets.
          </span>
        </h1>

        {/* Subheadline */}
        <p className="text-lg md:text-xl text-white/80 max-w-2xl mb-10 leading-relaxed">
          The all-in-one platform for fleet managers, dispatchers, and owner-operators.
        </p>

        {/* CTA buttons */}
        <div className="flex flex-col sm:flex-row items-center gap-4 mb-8">
          <a
            href="/auth/register"
            className="px-8 py-4 rounded-full text-white font-semibold text-base bg-gradient-to-r from-blue-600 to-cyan-500 hover:opacity-90 transition-opacity duration-200 shadow-lg shadow-blue-500/30"
          >
            Start Free Trial
          </a>
          <button
            onClick={handleWatchDemo}
            className="flex items-center gap-2 px-8 py-4 rounded-full text-white font-semibold text-base border border-white/40 hover:border-white hover:bg-white/10 transition-colors duration-200"
          >
            <PlayCircle className="w-5 h-5" />
            Watch Demo
          </button>
        </div>

        {/* Trust line */}
        <p className="text-white/50 text-sm">
          No credit card required &nbsp;&middot;&nbsp; Free 14 days &nbsp;&middot;&nbsp; Cancel anytime
        </p>
      </div>
    </section>
  );
}
